import { Platform, IonicModule } from "@ionic/angular";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TransactionCompleteComponent } from "../transaction-complete/transaction-complete.component";
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SCAN_INFO_MESSAGE } from "src/app/app.constants";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
@Component({
    selector: "app-add-new-card",
    templateUrl: "./add-new-card.component.html",
    styleUrls: ["./add-new-card.component.scss"],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TranslatePipe,
    ],
})
export class AddNewCardComponent implements OnInit {
  addNewCardForm: FormGroup;
  scanInfoMessage = SCAN_INFO_MESSAGE;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  constructor(
    private transactionDialog: MatDialog,
    private bottomSheetRef: MatBottomSheetRef<AddNewCardComponent>,
    private fb: FormBuilder,
    private platform: Platform,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          this.selectedLanguage = l;
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
    this.validateNewCardForm();
    this.authService?.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
  }

  ngOnInit() {}

  onSubmit() {
    this.bottomSheetRef.dismiss(true);
    this.transactionDialog.open(TransactionCompleteComponent, {
      panelClass: "dialog-size",
      width: "96vh",
      position: {
        top: "25vh",
        left: "3.5vh",
      },
      backdropClass: "back-drop-color",
    });
  }

  validateNewCardForm() {
    this.addNewCardForm = this.fb.group({
      cardNumber: [""],
      holderName: [""],
      expiryDate: [""],
      cvcCode: [""],
    });
  }

  closeBottomSheet() {
    this.bottomSheetRef.dismiss();
  }

  showScanError() {
    this.snackBar.open(this.scanInfoMessage, "OK!", {
      duration: 3000,
      verticalPosition: "top",
    });
  }
}
